<div class="d-flex justify-content-end mt-4">
  <button type="button" class="btn btn-primary fw-semibold" (click)="goBack()">
    <i class="bi bi-arrow-left"></i>
    Indietro
  </button>
</div>

<div class="row g-2 mb-2 mt-4">
  <div class="col-6">
    <h5>
      Risorsa: <strong>{{ risorsa.nomeRisorsa }}</strong>
    </h5>
  </div>
  <div class="col-6">
    <h5>
      Livello: <strong>{{ livello }}</strong>
    </h5>
  </div>
  <div class="col-6">
    <h5>
      Matricola: <strong>{{ risorsa.risorsa }}</strong>
    </h5>
  </div>
  <div class="col-6">
    <h5>
      Data approvazione: <strong>{{ presaVisione?.dataPresaVisione ? presaVisione?.dataPresaVisione : '' }}</strong>
    </h5>
</div>
<div class="rounded bg-white shadow-sm mt-4 pb-3 pt-4 px-4 w-100">
  <div>
    <h5 class="col-auto fw-bold">
      Timesheet
    </h5>
  </div>

  <div class="row justify-content-center">
    <div class="col-12">
      @if (timesheet.length > 0) {
      <app-tabella-commesse [anno]="anagraficaTimesheet?.anno ?? 0" [mese]="anagraficaTimesheet?.mese ?? 0"
        [utenteRisorsa]="true" [timesheets]="timesheet" [giorniModificati]="giorniModificati"></app-tabella-commesse>
      } @else {
      <p class="w-100 text-center">Nessun timesheet trovato</p>
      }
    </div>
  </div>
</div>

<div class="rounded bg-white shadow-sm mt-4 mb-4 pb-3 pt-4 px-4 w-100">
  <div class="row g-3 mb-3 justify-content-between">
    <h5 class="col-auto fw-bold">Richieste di modifica</h5>
    <span class="col-auto">
      <button type="button" class="btn btn-primary fw-semibold" (click)="apriModaleModifica()"
        [disabled]="!(presaVisione?.idStatoPresaVisioneTimesheet ===
        statiPresaVisione.Non_Presa && presaVisione?.idMotivazioneMancataPresaVisione === null)">
        <!-- && anagraficaTimesheet?.isPresaVisioneAbilitata)"> -->
        <i class="bi bi-plus-lg me-1"></i>
        Nuova richiesta
      </button>
    </span>
  </div>
  <div class="row justify-content-center">
    <div class="col-12">
      @if (richiesteModifica.length > 0) {
      <app-tabella-modifiche
        [modifiche]="richiesteModifica"
        [attore]="attore"
        [isDettaglio]="true"
        [anagraficaTimesheet]="anagraficaTimesheet"
        (iconItemEvent)="iconClick($event)"
      ></app-tabella-modifiche>
      } @else {
      <p class="w-100 text-center">Nessuna richiesta presente</p>
      }
    </div>
  </div>
</div>
@if([attori.CFO, attori.DirettoreGenerale, attori.ResponsabilePrimoLivello].includes(attore) &&
  timesheet.length > 0 && presaVisione?.idStatoPresaVisioneTimesheet ===
  statiPresaVisione.Non_Presa && presaVisione?.idMotivazioneMancataPresaVisione === null) {
<div class="col-12 d-flex justify-content-end mt-4 mb-4">
  <button type="button" class="btn btn-primary fw-semibold position-save-button" (click)="approvazioneTimesheet()">
    <i class="bi bi-check-lg me-1"></i>
    Approva timesheet
  </button>
</div>
}
